const TavilyIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    height="1em"
    width="1em"
    {...props}
  >
    {/* Example SVG path - Replace with Tavily logo path */}
    <circle cx="12" cy="12" r="10" />
  </svg>
);
export default TavilyIcon;
